module.exports = __webpack_public_path__ + "static/media/Step2.9.a57dc094.png";